import Mustache from '../../../vendors/mustache';
import templates from './templates/templates';
import {
  openIframeAuth,
  forceLogout
} from '../../ramblerId';
import sendPrimeAnalytics from '../../analytics';
import { checkIsMobile } from '../../helpers';

const personalEl = document.querySelector('.js-personal');
const menuButtonEl = document.querySelector('.js-dropdown-menu-button');

/**
 * Общий обработчик событий DOM контейнера с профилем
 * @param event
 */
const clickHandler = (event) => {
  const { target } = event;
  const { classList } = target;

  if (classList.contains('js-login')) {
    sendPrimeAnalytics('click', 'login');
    openIframeAuth();
  }

  if (classList.contains('js-logout')) {
    forceLogout();
  }
};

const sendShowProfileAnalyticsOnce = () => {
  if (!sendShowProfileAnalyticsOnce.alreadySent) {
    sendPrimeAnalytics('show', 'login');
    sendShowProfileAnalyticsOnce.alreadySent = true;
  }
};

/**
 * Функция рендера мобильного блока с профилем пользователя
 * @param state - статус пользователя, залогинен/разлогинен
 */
const renderMobileAuthElsInHeader = (state) => {
  const rootEl = personalEl || document.querySelector('.js-personal');
  state.subscriptionLink = window.AdvDailyHelper.subscriptionLink;
  rootEl.innerHTML = Mustache.render(
    state.isAuthorized ? templates.authorized : templates.notauthorized,
    { state: state }
  );
};

if (personalEl && checkIsMobile()) {
  // Add clickListener
  personalEl.addEventListener('click', clickHandler);
}

menuButtonEl && menuButtonEl.addEventListener('click', sendShowProfileAnalyticsOnce.bind(this));

export default renderMobileAuthElsInHeader;



// WEBPACK FOOTER //
// ./daily/assets/id/header/mobile/index.js